export const inwardFormData = () => ({
  inputData: {
    project_id: null,
    project_name: null,
    order_id: null,
    order_no: null,
    gst_no: null,
    invoice_id: null,
    warehouse_id: null,
    contractor_id: null,
    inward_date: "",
    delivery_challen_no: "",
    delivery_challen_document: "",
    remarks: "",
    created_by: 1,
    updated_by: 1,

    is_active: true,
    is_submitted: false,
    type: null,

    inward_documents: [
      {
        id: undefined,
        document: null,
        file: null,
        is_active: true,
      },
    ],

    inward_items: [
      {
        forceSave: true,
        invoice_item_id: null,
        id: undefined,
        is_make_item: true,
        buy_item_id: null,
        item_id: null,
        item_code: null,
        qty: null,
        remaining_qty: null,
        shortage_qty: null,
        inward_qty: null,
        reference: 1,
        remarks: "",
        provision_qty: null,
        is_active: false,
        move_to_provision: true,
        invoice_item_qty: null,
      },
    ],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "inwards",
    whereCondition: {
      is_active: true,
    },
    relation: [
      {
        modelName: "inward_documents",
        moduleAs: "inward_documents",
        foreignKey: "inward_id",
      },
      {
        modelName: "inward_items",
        moduleAs: "inward_items",
        foreignKey: "inward_id",
      },
    ],
  };

  const navigatePage = { back: "/inward-list" };

  const headerName = "Inward";

  const validationType = "InwardCreate";
  const createEndpoint = "/createInward";
  const getEndpoint = "/getInwardById";

  const referenceOptions = [
    { label: "DC", value: 1 },
    { label: "LR", value: 2 },
    { label: "E-bill", value: 3 },
  ];

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    referenceOptions,
  };
};

export const exportPageData = {
  data: {
    modelName: "inwards",
    relations: [
      { module: "projects", moduleAs: "project" },
      { module: "orders", moduleAs: "order" },
      { module: "invoices", moduleAs: "invoice" },
      { module: "warehouse_masters", moduleAs: "warehouse" },
      { module: "user_masters", moduleAs: "contractor" },
      { module: "user_masters", moduleAs: "createdBy" },
    ],
    search: {
      searchKeyword: "",
      field_name: [
        "delivery_challen_no",
        "order.order_no",
        "invoice.invoice_no",
        "warehouse.warehouse_name",
        "contractor.first_name",
      ],
    },
    pagination: { page: 1, pageSize: 10000 },
  },
  fileName: "inwardData.xlsx",
};
